import React from 'react';
import styled from 'styled-components';
import { Button, Drawer as BaseDrawer, IconButton } from '@material-ui/core';
import {
  Close,
  Edit,
  LibraryBooks,
  People,
  Power,
  SettingsInputComposite,
} from '@material-ui/icons';

import {
  FormSection,
  TextArea as BaseTextArea,
  TextInput as BaseTextInput,
} from '../forms';

export const EditButton = styled(Button).attrs({
  variant: 'contained',
  startIcon: <Edit />,
})`
  && {
    background-color: #ffffff;
    border-radius: 5px;
    padding: 10px 18px;

    &:hover {
      background-color: #eeeeee;
    }
  }

  & > .MuiButton-label {
    color: #007ade;
    font-size: 16px;
    font-weight: 500;
    font-family: 'Montserrat', sans-serif;
    line-height: 1.25;
  }
`;

export const Drawer = styled(BaseDrawer).attrs({
  anchor: 'right',
})`
  & > .MuiDrawer-paper {
    width: 790px;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    overflow: hidden;
  }
`;

Drawer.Header = styled.div`
  display: flex;
  align-items: center;
  gap: 40px;
  padding: 15px 25px;
  background: #005092;
`;

Drawer.CloseButton = styled(IconButton).attrs({
  size: 'small',
  children: <Close />,
})`
  color: #ffffff !important;
`;

Drawer.Title = styled.b`
  margin-right: auto;
  color: #ffffff;
  font-size: 18px;
  font-weight: 500;
  font-family: 'Montserrat', sans-serif;
`;

Drawer.Body = styled.div`
  padding: 30px;
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;
  width: 100%;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
`;

export const DetailsStatusRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  width: 100%;
  box-sizing: border-box;
`;

export const StatusSection = styled(FormSection).attrs({
  IconComponent: Power,
})`
  width: 30%;
  max-width: 30%;
  min-width: unset !important;
  box-sizing: border-box;
  flex-shrink: 0;
`;

export const DetailsSection = styled(FormSection).attrs({
  IconComponent: LibraryBooks,
})`
  width: 70%;
  max-width: 70%;
  min-width: unset !important;
  box-sizing: border-box;
  flex-shrink: 0;
`;

export const AudienceSection = styled(FormSection).attrs({
  IconComponent: People,
})`
  width: 100%;
  max-width: 100%;
  min-width: unset !important;
  box-sizing: border-box;
`;

export const StagesSection = styled(FormSection).attrs({
  IconComponent: SettingsInputComposite,
})`
  width: 100%;
  max-width: 100%;
  min-width: unset !important;
  box-sizing: border-box;
`;

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const TextDisplay = styled(BaseTextInput).attrs({ disabled: true })`
  > .MuiInputBase-root {
    font-weight: 600;
  }
`;

export const TextAreaDisplay = styled(BaseTextArea).attrs({ disabled: true })`
  > .MuiInputBase-root {
    font-weight: 500;
  }
`;

export const LoadingMessage = styled.span.attrs({
  children: 'Loading...',
})`
  text-align: center;
  font-family: 'Montserrat', sans-serif;
`;

export const ErrorMessage = styled.span.attrs({
  children:
    'Failed to load the campaign. Please try again later. If the issue persists, please contact us.',
})`
  text-align: center;
  font-family: 'Montserrat', sans-serif;
`;

export const ExportButton = styled.span`
  color: #007ade;
  font-weight: 500;
  font-family: 'Montserrat', sans-serif;
  cursor: pointer;
  font-size: 15px;
  margin-top: -5px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;

  &:hover {
    text-decoration: underline;
  }
`;
